import EstagioRoteiro from "./EstagioRoteiro";
import { BaseModel } from "model/BaseModel";

export default class Roteiro implements BaseModel{
	id: number;
    codigo: string | null="";
	codigoRoteiro: string;
	nome: string;
	estagios: EstagioRoteiro[];

    constructor(
        id: number = 0,
        codigoRoteiro: string = "",
        nome: string = "",
        estagios: EstagioRoteiro[] = []
    ) {
        this.id = id;
        this.codigoRoteiro = codigoRoteiro;
        this.nome = nome;
        this.estagios = estagios;
    }
}